import React from "react";

export default ({ children, ...modifiers }) => {
  let className = "text";
  className = Object.keys(modifiers).reduce(
    (acc, modifier) => `${acc} -${modifier}`,
    className
  );
  return <p className={className}>{children}</p>;
};
